// services/inventoryApi.ts
import apiClient from "./apiClient";

export interface StockTransaction {
  id: number;
  type: "in" | "out";
  quantity: number;
  reason: string;
  createdAt: string;
  Product: {
    id: number;
    name: string;
    sku: string;
  };
  creator: {
    id: number;
    ownerName: string;
  };
}

export interface StockBalance {
  productId: number;
  productName: string;
  currentStock: number;
  totalIn: number;
  totalOut: number;
}

export interface TransactionsResponse {
  transactions: StockTransaction[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export const inventoryApi = {
  getAll: async (params: {
    page: number;
    limit: number;
    startDate?: string;
    endDate?: string;
    productId?: number;
  }): Promise<TransactionsResponse> => {
    const response = await apiClient.get("/inventory", { params });
    return response.data;
  },
  create: async (data: {
    productId: number;
    type: "in" | "out";
    quantity: number;
    reason: string;
  }): Promise<{ message: string; transaction: StockTransaction }> => {
    const response = await apiClient.post("/inventory", data);
    return response.data;
  },
  getStockByProduct: async (productId: number): Promise<StockBalance> => {
    const response = await apiClient.get(`/inventory/stock/${productId}`);
    return response.data;
  },
  delete: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/inventory/${id}`);
    return response.data;
  },
  restore: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.post(`/inventory/restore/${id}`);
    return response.data;
  },
};
